import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatPromotionModel } from 'src/oldApp/model/cat-promotion.model';
import { CreateCombinationsSend } from 'src/oldApp/model/create-combinations-send.model';
import { DependencyAffiliateModel, HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { VwCommissionPanelModel } from 'src/app/model/vw-commission-panel.model';
import { CatCategoryProductService } from 'src/oldApp/services/cat-category-product.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CreatorService } from 'src/app/services/creator.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { VwCommissionConfiguratorService } from 'src/app/services/vw-commission-configurator.service';
import { VwCommissionPanelService } from 'src/oldApp/services/vw-commission-panel.service';
import { ModalVwCommissionPanelComponent } from 'src/oldApp/shared/modal-vw-commission-panel/modal-vw-commission-panel.component';
import { ModalCommissionConfigurationComponent } from 'src/oldApp/shared/modal-commission-configuration/modal-commission-configuration.component';

@Component({
  selector: 'app-commission-configuration',
  templateUrl: './commission-configuration.component.html',
  styleUrls: ['./commission-configuration.component.css']
})
export class CommissionConfigurationComponent implements OnInit {

  // Estado de la página
  public viewStatus:number=0;
  public viewCategories:number=0;
  public viewCommission:number=0;
  public viewPromotions:number=0;
  public page='ComissionConfiguration';
  public formIsLocked:boolean=false;
  public formHeight=0;
  public tableItems:VwCommissionPanelModel[]=[];
  public tableItemsFiltered:VwCommissionPanelModel[]=[];
  public tableMissingConfigs:VwCommissionPanelModel[]=[];
  public loading:number=0;

  // Seleccion de Catalogos
  public selectedCommissionGroup:any[]=[];
  public selectedEmployeeJobs:any[]=[];
  public selectedPaymentFrequencies:any[]=[];
  public selectedPaymentTerms:any[]=[];
  public selectedBusinessProducts:any[]=[];
  public selectedAnchorTypes:any[]=[];
  public selectedProducts:any[]=[];
  public selectedAfiliates:any[]=[];
  public selectedPromos:any[]=[];
  public selectedCategories:any[]=[];
  public selectedSchemas:any[]=[];
  public commission:number=null;

  // Catalogos
  public employeeJobCatalog:CatalogModel[]=[];
  public commissionGroupCatalog:CatalogModel[]=[];
  public paymentFrequencyCatalog:HMGenericCatalog[]=[];
  public paymentTermCatalog:CatalogModel[]=[];
  public businessProductCatalog:HMGenericCatalog[]=[];
  public anchorTypeCatalog:HMGenericCatalog[]=[];
  public productCatalog:CatalogModel[]=[];
  public afiliateCatalog:CatalogModel[]=[];
  public promoCatalog:CatPromotionModel[]=[];
  public categoryCatalog:CatalogModel[]=[];
  public schemaCatalog:CatalogModel[]=[];

  // Selección Inicial
  public selectedProductsDD:string[]=[];
  public selectedAfiliatesDD:string[]=[];
  public selectedPaymentTermsDD:string[]=[];
  public selectedEmployeeJobsDD:string[]=[];
  public selectedSchemasDD:string[]=[];
  public selectedCategoriesDD:string[]=[];
  public selectedPromosDD:string[]=[];


  // Opciones de Datatable
  @ViewChild(DataTableDirective, {static: false})
  private datatableElement: DataTableDirective;
  public dtOptions:any={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: [
      // {
      //   text:'Seleccionar todo',
      //   action:()=> this.selectAll()
      // },
      { text: 'Editar',
        action:()=> this.edit()
      },
      'csv',
      'excel'
    ],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  // Mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                         // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},  // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')}
  };

  // Inyecta los Servicios
  constructor(
    private vwCommissionConfiguratorService:VwCommissionConfiguratorService,
    private catEmployeeJobService:CatEmployeeJobService,
    private hypermatrixCatalogService:HypermatrixCatalogsService,
    private catCategoryProductService:CatCategoryProductService,
    private otherCatalogsService:OtherCatalogsService,
    private promoService:VwCommissionConfiguratorService,
    private vwComissionPanelService:VwCommissionPanelService,
    private modalService:NgbModal,
    private creator:CreatorService,
    private utils:UtilitiesService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.dtOptions.data=this.tableItemsFiltered;
    this.dtOptions.columns=this.makeTableColumns();
    this.getCatalogs();
  }

  // Obtiene la Información de los Catalogos
  getCatalogs=()=> {
    forkJoin(
      this.catEmployeeJobService.getCommissionGroup(),                   //Grupo de Comisiones/Puestos
      //this.catEmployeeJobService.catalog(),                            //Puestos
      //this.hypermatrixCatalogService.getCatalog('PaymentPeriodType'),  //Frecuencia/Periodo de Pago
      //this.vwCommissionConfiguratorService.getPayments(),              //Plazo
      this.hypermatrixCatalogService.getCatalog('BusinessProductType'),  //Línea de Negocio
      this.hypermatrixCatalogService.getCatalog('OwnerType'),            //Tipo de Fondeo
      //this.hypermatrixCatalogService.getCatalog('ProductosCOE'),       //Producto
      //this.vwCommissionConfiguratorService.getAfiliates(),               //Convenio
      //this.catCategoryProductService.catalog(),                        //Categoria
      //this.otherCatalogsService.getListSchema()                        //Esquema
    )
    .pipe(
      tap(([groupJobResp, bpResp, anchorResp]:[any, any, any])=> {
        if(groupJobResp && bpResp && anchorResp) {

          this.commissionGroupCatalog=groupJobResp.data.filter(c=> c.id!==3).sort(this.utils.sortBy('description'));
          //this.employeeJobCatalog=jobResp.data;
          //this.paymentFrequencyCatalog=payResp.data;
          //this.paymentTermCatalog=termResp.data;
          this.businessProductCatalog=bpResp.data;
          this.anchorTypeCatalog=anchorResp.data;
          //this.productCatalog=prodResp.data.sort(this.utils.sortBy('description'));
          //this.afiliateCatalog=afiResp.data.sort(this.utils.sortBy('description'));
          //this.categoryCatalog=catResp.data.filter(cat=> cat.id!==5);
          //this.schemaCatalog=scResp.data;

          // crear tabla
          this.dtOptions.data=this.tableItemsFiltered;
          this.dtOptions.columns=this.makeTableColumns();
          this.dtOptions.drawCallback=this.bindCheckboxes;
          this.viewStatus=1;
        }
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al cargar catálogos.'));
      })
    )
    .subscribe();
  }

  // Eventos de Selección
  businessProductChange=e=>{

    if(e.length > 0){

      this.selectedBusinessProducts=e;
      console.log(">> this.selectedBusinessProducts= ", this.selectedBusinessProducts);

      this.selectedProductsDD=[];
      this.selectedAfiliatesDD=[];
      this.selectedPaymentTermsDD=[];

      this.selectedProducts=[];
      this.selectedAfiliates=[];
      this.selectedPaymentTerms=[];

      this.productCatalog=[];
      this.afiliateCatalog=[];
      this.paymentTermCatalog=[];

      this.viewPromotions = 0;
      this.viewCommission = 0;

      let businessProductId:number[]=[];
      this.selectedBusinessProducts.forEach((el)=>{
        businessProductId.push(el.idCatalogType);
      });

      //Cargar PRODUCTOS X LINEA DE NEGOCIO seleccionada
      console.log(">> businessProductId= " + businessProductId);
      this.vwCommissionConfiguratorService.getFinancingTypesByBusinessProduct(businessProductId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.productCatalog=resp.data;
          this.getConfigurations();
        }
      });

    }

  };

  anchorTypeChange=e=> {
    console.log(">> this.selectedAnchorTypes= ", e);
    this.selectedAnchorTypes=e; this.getConfigurations();
  };

  productChange=e=> {

    if(e.length > 0){

      this.selectedProducts=e;
      console.log(">> this.selectedProducts= ", this.selectedProducts);

      this.selectedAfiliatesDD=[];
      this.selectedPaymentTermsDD=[];

      this.selectedAfiliates=[];
      this.selectedPaymentTerms=[];

      this.afiliateCatalog=[];
      this.paymentTermCatalog=[];

      this.viewPromotions = 0;
      this.viewCommission = 0;

      let financingTypeId:number[]=[];
      this.selectedProducts.forEach((el)=>{
        financingTypeId.push(el.id);
      });

      //Cargar CONVENIOS X PRODUCTO seleccionado
      console.log(">> selectedProducts= " + financingTypeId);
      this.vwCommissionConfiguratorService.getAfiliatesByFinancingType(financingTypeId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.afiliateCatalog=resp.data.filter(item => item.id > 0);
          this.getConfigurations();
        }
      });

    }

  };

  afiliateChange=e=> {

    if(e.length > 0){

      this.selectedAfiliates=e;
      console.log(">> this.selectedAfiliates= ", e);

      this.selectedPaymentTermsDD=[];
      this.selectedPaymentTerms=[];
      this.paymentTermCatalog=[];

      this.viewPromotions = 0;
      this.viewCommission = 0;

      let afiliateId:number[]=[];
      this.selectedAfiliates.forEach((el)=>{
        afiliateId.push(el.id);
      });

      //Cargar PLAZOS X CONVENIO seleccionado
      console.log(">> selectedAfiliates: " + afiliateId);
      this.vwCommissionConfiguratorService.getPaymentTermsByAfiliate(afiliateId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.paymentTermCatalog=resp.data.filter(item => item.id > 0);
          this.paymentTermCatalog.forEach((item,index)=>{
              if(item.id===21 || item.id===22 || item.id===23) this.paymentTermCatalog.splice(index, 1);
          });
          this.getConfigurations();
        }
      });

    }

  }

  paymentTermChange=e=> {

    if(e.length > 0){
      this.selectedPaymentTerms=e;
      console.log(">> this.selectedPaymentTerms= ", this.selectedPaymentTerms);

      this.viewPromotions = 0;
      this.viewCommission = 0;

      if(this.selectedSchemas.length>0 && this.selectedSchemas[0].id === 5){ //Si el ESQUEMA es "COMISIÓN POR FINANCIAMIENTO"
        this.showPromotions();   //Obtener las PROMOCIONES X NEGOCIO, TIPO FONDEO, PRODUCTO, CONVENIO Y PLAZO seleccionado
        this.viewCommission = 1; //Mostrar el campo de captura de la COMISIÓN en la ventana de guardar "Configuraciones Nuevas"
      }else{
        this.getConfigurations();
      }

    }

  }

  commissionGroupChange=e=>{

    if(e.length > 0){

      this.selectedCommissionGroup = e;
      console.log(">> this.selectedCommissionGroup= ", this.selectedCommissionGroup);

      this.selectedEmployeeJobsDD = [];
      this.selectedSchemasDD=[];
      this.selectedCategoriesDD=[];
      this.selectedPromosDD=[];

      this.selectedEmployeeJobs=[];
      this.selectedSchemas=[];
      this.selectedCategories=[];
      this.selectedPromos=[];

      this.employeeJobCatalog=[];
      this.schemaCatalog=[];
      this.categoryCatalog=[];
      this.promoCatalog=[];

      this.viewCategories = 0;
      this.viewPromotions = 0;
      this.viewCommission = 0;

      this.catEmployeeJobService.getByCommissionGroup(this.selectedCommissionGroup[0].id)
      .subscribe((resp:any)=> {
        console.log(">>> response getByCommissionGroup: "+ JSON.stringify(resp));
        if(resp && resp.codeHttpStatus===200) {
          this.employeeJobCatalog=resp.data;
          this.getConfigurations();
        }
      });

    }

  }

  employeeJobChange=e=> {

    if(e.length > 0){

      this.selectedEmployeeJobs=e;
      console.log(">> this.selectedEmployeeJobs= ", this.selectedEmployeeJobs);

      this.selectedSchemasDD=[];
      this.selectedCategoriesDD=[];
      this.selectedPromosDD=[];

      this.selectedSchemas=[];
      this.selectedCategories=[];
      this.selectedPromos=[];

      this.schemaCatalog=[];
      this.categoryCatalog=[];
      this.promoCatalog=[];

      this.viewCategories = 0;
      this.viewPromotions = 0;
      this.viewCommission = 0;

      let selectedEmployeeJobsId = "";
      this.selectedEmployeeJobs.forEach((el)=>{
        selectedEmployeeJobsId = selectedEmployeeJobsId + el.id + ",";
      });
      selectedEmployeeJobsId = selectedEmployeeJobsId.substring(0, selectedEmployeeJobsId.length - 1);

      console.log(">> selectedEmployeeJobsId= " + selectedEmployeeJobsId);
      this.otherCatalogsService.getListSchemaByEmployeeJob(selectedEmployeeJobsId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.schemaCatalog=resp.data;
          this.getConfigurations();
        }
      });

    }

  };

  schemaChange=e=> {

    if(e.length > 0){

      this.selectedSchemas=e;
      console.log(">> this.selectedSchemas= ", this.selectedSchemas);

      this.selectedCategories=[];
      this.selectedPromos=[];

      this.selectedCategoriesDD=[];
      this.selectedPromosDD=[];

      this.categoryCatalog=[];
      this.promoCatalog=[];

      this.viewCategories = 0;
      this.viewPromotions = 0;
      this.viewCommission = 0;

      this.getConfigurations();

      if(this.selectedSchemas[0].id === 3){ //Si el ESQUEMA es "COMISIÓN POR CLASIFICACIÓN DE PRODUCTO"
        this.showCategories();  //Obtener las CATEGORIAS del PUESTO seleccionado
        //this.showPromotions();   //Obtener las PROMOCIONES X NEGOCIO, TIPO FONDEO, PRODUCTO, CONVENIO Y PLAZO seleccionado
      }else{
        if(this.selectedSchemas[0].id === 5){ //Si el ESQUEMA es "COMISIÓN POR FINANCIAMIENTO"
          this.showPromotions();   //Obtener las PROMOCIONES X NEGOCIO, TIPO FONDEO, PRODUCTO, CONVENIO Y PLAZO seleccionado
          this.viewCommission = 1; //Mostrar el campo de captura de la COMISIÓN en la ventana de guardar "Configuraciones Nuevas"
          // this.datatableElement.dtInstance.then((dtInstance)=> {
          //   dtInstance.columns[9].visible(true, true);
          // });
        }
      }
    }
  };

  categoryChange=e=> {
    console.log(">> this.selectedCategories= ", e);
    this.selectedCategories=e;
    this.getConfigurations();
  };

  promoChange=e=> {
    this.selectedPromos=e; this.getConfigurations();
  };

  // Valida si se muestra
  showCategorySelector=()=> this.selectedSchemas.filter(t=> t.id==3 ).length>0;
  showCommissionInput=()=> this.selectedSchemas.filter(t=> t.id==5 ).length>0;
  commissionError=()=> this.commission!==0 && !this.commission;
  updateCommission=e=> this.commission=Number(e);
  showGenerateButton=()=> //Valida si se muestra el botón de "Generar"
    this.selectedBusinessProducts.length>0 &&   //Linea de Negocio
    this.selectedAnchorTypes.length>0 &&        //Tipo Fondeo
    this.selectedProducts.length>0 &&           //Producto
    this.selectedAfiliates.length>0 &&          //Convenio
    this.selectedPaymentTerms.length>0 &&       //Plazo
    this.selectedCommissionGroup.length>0;      //Grupo Comisión/Puesto
    //this.selectedEmployeeJobs.length>0 &&     //Puesto
    //this.selectedSchemas.length>0 &&          //Esquema
    //(
    //(this.selectedSchemas.indexOf(3)<0) || (this.selectedSchemas.indexOf(3)>=0 && this.selectedCategories.length>0)
    //)

  // Muestra las CATEGORIAS del PUESTO seleccionado si el Grupo de Comisión es "PROMOTOR"
  public showCategories(){
    this.viewCategories = 1;
    if(this.selectedEmployeeJobs.length>0){
      let employeeJobId = this.selectedEmployeeJobs[0].id;
      this.catCategoryProductService.getByEmployeeJob(employeeJobId).subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.categoryCatalog=resp.data.filter(cat=> cat.id!==5);
        }
      });
    }
  }

  // Muestra las PROMOCIONES X NEGOCIO, TIPO FONDEO, PRODUCTO, CONVENIO Y PLAZO seleccionado
  public showPromotions=()=> {
    this.viewPromotions = 1;

    let params={
      listBusinessProducts:this.selectedBusinessProducts.map(t=>t.id),
      listAnchorTypes:this.selectedAnchorTypes.map(t=>t.id),
      listFinancingTypes:this.selectedProducts.map(t=>t.id),
      listAfiliates:this.selectedAfiliates.map(t=>t.id),
      listPayments:this.selectedPaymentTerms.map(t=>t.id)
    }
    console.log(">> params= "+ params);
    forkJoin(
      this.vwCommissionConfiguratorService.getFinancinfByAfiliatePayment(params)
    )
    .pipe(
      tap((resp:any)=> {
        if(resp && resp[0].codeHttpStatus===200) {
          this.promoCatalog=resp[0].data.filter(item => item.id !== "ALL");
          this.promoCatalog=this.promoCatalog.sort(this.utils.sortBy('description'));
        }
        else if(resp && resp[0].codeHttpStatus===404) {
          this.toastr.info(resp[0].messageError);
          this.promoCatalog=[];
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.promoCatalog=[];
        return of(this.toastr.error('Ocurrió un error al leer promociones.'))
      })
    )
    .subscribe();
  }

  // Consulta las Configuraciones de acuerdo a los Catalogos Seleccionados
  public getConfigurations(){
      if(this.selectedBusinessProducts.length>0 && //Linea de Negocio
        this.selectedAnchorTypes.length>0 &&       //Tipo Fondeo
        this.selectedProducts.length>0 &&          //Producto
        this.selectedAfiliates.length>0 &&         //Convenio
        this.selectedPaymentTerms.length>0 &&      //Plazo
        this.selectedCommissionGroup.length>0      //Grupo Comisión/Puesto
        //&& this.selectedEmployeeJobs.length>0    //Puesto
        //&& this.selectedSchemas.length>0         //Esquema
        //&& (                                     //Categoría
        //(this.selectedSchemas.indexOf(3)<0) ||
        //(this.selectedSchemas.indexOf(3)>=0 && this.selectedCategories.length>0)
        //)

      ){
        this.loading = 1;
        //setTimeout( () => {
          this.generateConfigs();
        //}, 5000 );

      }
  }

  generateConfigs=()=> {

    let PaymentTermsSend:any;
    let EmployeeJobsSend:any;
    let SchemasSend:any;
    let CategoriesSend:any;
    let PromotionsSend:any;

    if(this.selectedPaymentTerms.length>0){
      PaymentTermsSend=this.selectedPaymentTerms; //Si hay PLAZOS seleccionados, se envian los seleccionados
    }else{
      PaymentTermsSend=this.paymentTermCatalog;  //Si no hay PLAZOS seleccionados, se deben de aobtener todos los PLAZOS relacionados a la CATEGORIA
    }

    if(this.selectedEmployeeJobs.length>0){
      EmployeeJobsSend=this.selectedEmployeeJobs; //Si hay PUESTOS seleccionados, se envian los seleccionados
    }else{
      EmployeeJobsSend=this.employeeJobCatalog;  //Si no hay PUESTOS seleccionados, se envian todos los del catálogo de PUESTOS
    }

    if(this.selectedSchemas.length>0){
      SchemasSend=this.selectedSchemas; //Si hay ESQUEMAS seleccionados, se envian los seleccionados
    }else{
      SchemasSend=[];  //Si no hay ESQUEMAS seleccionados, no mandar nada
    }

    if(this.selectedCategories.length>0){
      CategoriesSend=this.selectedCategories; //Si hay CATEGORIAS seleccionadas, se envian los seleccionados
    }else{
      CategoriesSend=[];
    }

    if(this.selectedPromos.length>0){
      PromotionsSend=this.selectedPromos; //Si hay PROMOCIONES seleccionadas, se envian los seleccionados
    }else{
      PromotionsSend=[];
    }

    let createCombination:CreateCombinationsSend= new CreateCombinationsSend();
    if(this.selectedBusinessProducts.length>0 //Linea de Negocio
      &&this.selectedAnchorTypes.length>0     //Tipo Fondeo
      &&this.selectedProducts.length>0        //Producto
      &&this.selectedAfiliates.length>0       //Convenio
      //&&this.selectedEmployeeJobs.length>0  //Puesto (OPCIONAL)
      //&&this.selectedSchemas.length>0       //Esquema (OPCIONAL)
      //&&this.selectedCategories.length>0    //Categoria (OPCIONAL)
    ){

      this.selectedBusinessProducts.forEach((el)=>{el.id = el.idCatalogType;}) ;
      this.selectedAnchorTypes.forEach((el)=>{el.id = el.idCatalogType;}) ;
      this.selectedProducts.forEach((el)=>{el.id = el.id;}) ;

      //console.log("this.selectedBusinessProducts.forEach((el)=>{el.id = el.idCatalogType;}) ;"+JSON.stringify(this.selectedBusinessProducts.forEach((el)=>{el.id = el.idCatalogType;})) +"----------------------------- "+JSON.stringify(this.selectedBusinessProducts));
      createCombination.listBusinessProduct=this.selectedBusinessProducts; //Lineas de Negocio
      createCombination.listAnchor=this.selectedAnchorTypes;              //Tipos Fondeo
      createCombination.listFinancing=this.selectedProducts;              //Productos
      createCombination.listAfiliate=this.selectedAfiliates;              //Convenios
      createCombination.listPaymentTerm=PaymentTermsSend;                 //Plazos
      createCombination.listEmployeeJob=EmployeeJobsSend;                 //Puestos
      createCombination.listSchema=SchemasSend;                           //Esquemas
      createCombination.listCategory=CategoriesSend;                      //Categorias
      createCombination.listPromotion=PromotionsSend;                     //Promociones

      let commissionGroup = this.selectedCommissionGroup[0].id;
      if(commissionGroup === 1){
          // Consultar Configuraciones de Tercia
          this.getConfigsTertia(createCombination);
      }else{
          // Consultar Configuraciones de Promotor
          this.getConfigsFinancing(createCombination);
      }

    }else{
      this.loading = 0;
      this.toastr.info("Faltan seleccionar campos!");
    }

  }

  getConfigsTertia=(createCombination:CreateCombinationsSend)=>{
    this.vwComissionPanelService.getConfigsTertia(createCombination)
    .subscribe((resp:any)=> {
      if(resp && resp.codeHttpStatus===200) {
        this.loading = 0;
        this.datatableElement.dtInstance.then((dtInstance)=> {
          this.tableItemsFiltered=resp.data.filter(item => item.promotionId !== "ALL");
          this.tableItemsFiltered.forEach((it, ind)=> {
            if(it.commissionId<=0) it.commissionId=-(ind+1);
          });
          dtInstance.clear();
          dtInstance.rows.add(this.tableItemsFiltered).draw(false);
          if(resp.data2.length > 0){
            this.tableMissingConfigs = resp.data2.filter(item => item.promotionId !== "ALL");;
            let modalRef=this.modalService.open(ModalCommissionConfigurationComponent, {centered:true, size: 'xl', backdrop:'static', keyboard:false});
                modalRef.componentInstance.header='Hay (' + this.tableMissingConfigs.length + ') Configuraciones disponibles!';
                modalRef.componentInstance.text='Seleccione las configuraciones que desee crear:';
                modalRef.componentInstance.acceptText='Crear Configuraciones';
                modalRef.componentInstance.cancelText='Salir sin Crear';
                modalRef.componentInstance.tableItemsFiltered = this.tableMissingConfigs;
                modalRef.result.then(
                  data=> console.log(data),
                  reason=> {
                    console.log(">> Configuraciones Seleccionadas = ", reason);
                    if(reason != null && reason.length >0)  //==='accept'
                    {
                      this.createMissingConfigsTertia(reason, resp.messageError);
                    }
                  }
                );
          }
        });
      }
    });
  }

  getConfigsFinancing=(createCombination:CreateCombinationsSend)=>{
    console.log(">>Request:" +createCombination)
    this.vwComissionPanelService.getConfigsFinancing(createCombination)
    .subscribe((resp:any)=> {
      if(resp && resp.codeHttpStatus===200) {
        this.loading = 0;
        this.datatableElement.dtInstance.then((dtInstance)=> {
          this.tableItemsFiltered=resp.data.filter(item => item.promotionId !== "ALL");
          this.tableItemsFiltered.forEach((it, ind)=> {
            if(it.commissionId<=0) it.commissionId=-(ind+1);
          });
          dtInstance.clear();
          dtInstance.rows.add(this.tableItemsFiltered).draw(false);
          if(resp.data2.length > 0){
            this.tableMissingConfigs = resp.data2.filter(item => item.promotionId !== "ALL");
            let modalRef=this.modalService.open(ModalCommissionConfigurationComponent, {centered:true, size: 'lg', backdrop:'static', keyboard:false});
                modalRef.componentInstance.header= 'Hay (' + this.tableMissingConfigs.length + ') Configuraciones disponibles!';
                modalRef.componentInstance.text='Seleccione las Configuraciones que desee crear:';
                modalRef.componentInstance.acceptText='Crear Configuraciones';
                modalRef.componentInstance.cancelText='Salir sin Crear';
                modalRef.componentInstance.tableItemsFiltered = this.tableMissingConfigs;
                modalRef.componentInstance.selectedEmployeeJobs = this.selectedEmployeeJobs;
                modalRef.componentInstance.selectedSchemas = this.selectedSchemas;
                modalRef.result.then(
                  data=> console.log(data),
                  reason=> {
                    console.log(">> Configuraciones Seleccionadas = ", reason);
                    if(reason != null && reason.length >0)  //==='accept'
                    {
                      let savePromotion=0;
                      if(this.selectedEmployeeJobs.length>0 && this.selectedSchemas.length>0){
                        let employeeId = this.selectedEmployeeJobs[0].id;
                        let schemaId = this.selectedSchemas[0].id;
                        if((employeeId===1 || employeeId===2) && (schemaId ===3 || schemaId ===5)){
                          savePromotion=1;
                        }
                      }
                      this.createMissingConfigsFinancing(reason, resp.messageError, savePromotion);
                    }
                  }
                );
          }
        });
      }
    });
  }

  createMissingConfigsTertia=(tableItemsSelected:VwCommissionPanelModel[], randomTemp:string)=> {
    // crear configuraciones
    this.vwComissionPanelService.createMissingConfigsTertia(tableItemsSelected, randomTemp)
    .subscribe((resp:any)=> {
      if(resp && resp.codeHttpStatus===200) {
        this.toastr.success('Las configuraciones se han generado correctamente!');
        this.datatableElement.dtInstance.then((dtInstance)=> {
          this.tableItemsFiltered=resp.data;
          dtInstance.clear();
          dtInstance.rows.add(this.tableItemsFiltered).draw(false);
        });
        /*let modalRef=this.modalService.open(ModalAlertComponent, {centered:true, size:'sm', backdrop:'static', keyboard:false});
        modalRef.componentInstance.text='Se han guardado la configuraciones seleccionadas!';
        modalRef.result.then(
          data=> console.log(data),
          reason=> {
            if(reason ==='accept') {}
          }
        );*/
      }else{
        this.toastr.error('Ocurrió un error al generar las configuraciones!')
      }
    });
  }

  createMissingConfigsFinancing=(tableItemsSelected:VwCommissionPanelModel[], randomTemp:string, savePromotion:number)=> {
    // crear configuraciones
    this.vwComissionPanelService.createMissingConfigsFinancing(tableItemsSelected, randomTemp, savePromotion)
    .subscribe((resp:any)=> {
      console.log(">>> response createMissingConfigsFinancing: "+ JSON.stringify(resp));
      if(resp && resp.codeHttpStatus===200) {
        this.toastr.success('Las configuraciones se han generado correctamente!');
        this.datatableElement.dtInstance.then((dtInstance)=> {
          console.log(">>> nuevas configuraciones=" + resp.data);
          this.tableItemsFiltered=resp.data;
          dtInstance.clear();
          dtInstance.rows.add(this.tableItemsFiltered).draw(false);
        });
      }else{
        this.toastr.error('Ocurrió un error al generar las configuraciones!')
      }
    });
  }

  edit=()=> {
    // TODO
    let items=this.tableItemsFiltered.filter(it=> it.selected);
    if(items.length>0 && this.selectedCommissionGroup.length>0) {
      let commissionGroup = this.selectedCommissionGroup[0].id;
      let modalRef=this.modalService.open(ModalVwCommissionPanelComponent, {centered:true, backdrop:'static', keyboard:false});
      modalRef.componentInstance.items=JSON.parse(JSON.stringify(items));
      modalRef.componentInstance.page=this.page;
      modalRef.componentInstance.mode='edit';
      modalRef.componentInstance.commissionGroup=commissionGroup;
      modalRef.result.then(
        data=> console.log(data),
        reason=> {
          console.log(reason);
          this.generateConfigs();
        }
      );
    }
  }

  // TABLA
  bindCheckboxes=()=> {
    let buttons=document.getElementsByClassName('select-row');
    for (var i=0; i<buttons.length; i++) {
      buttons[i].addEventListener('click', (e:any)=> {

        let id=Number(e.target.id.replace('customCheck-', ''));
        let item=this.tableItemsFiltered.find(it=> it.commissionId===id);
        let newSelected=!item.selected;

        this.datatableElement.dtInstance.then((dtInstance)=> {
          let items=this.tableItemsFiltered;
          items.forEach(it=> it.selected=false);

          item.selected=newSelected;

          dtInstance.clear();
          dtInstance.rows.add(this.tableItemsFiltered).draw(false);
        });

      });
    }
  }

  selectAll=()=> {
    this.datatableElement.dtInstance.then((dtInstance)=> {
      console.log(dtInstance.rows({page:'current'}).data().map(it=>it.commissionId))
      let items=this.tableItemsFiltered.filter(it=> dtInstance.rows({page:'current'}).data().map(i=>i.commissionId).indexOf(it.commissionId)>=0);
      items.forEach(it=> it.selected=true);
      dtInstance.clear();
      dtInstance.rows.add(this.tableItemsFiltered).draw(false);
    })
  }

  makeTableColumns=()=> {
    let columns=[
      {title:'', data:function(data) {
        return '<div class="custom-control custom-checkbox custom-control-solid">'+
            '<input type="checkbox" class="custom-control-input select-row" id="customCheck-'+data.commissionId+'" '+(data.selected?'checked':'')+'>'+
            '<label class="custom-control-label" for="customCheck-'+data.commissionId+'"></label>'+
        '</div>'
      }},

      // {title:'Id', data:'commissionId'},
      {title:'Línea de Negocio', data:'businessProductDesc'},
      {title:'Tipo de Fondeo', data:'ownerTypeDesc'},
      {title:'Producto', data:'financingTypeDesc'},
      {title:'Convenio', data:'afiliateDesc'},

      {title:'Plazo', data:'paymentDesc'},
      {title:'Puesto', data:'employeeJobDesc'},
      {title:'Esquema', data:'schemaDesc'},
      {title:'Categoría', data:'productCategoryDesc'},

      {title:'Promoción', data:'promotionId', visible:true},
      {title:'Comisión', data:function(data) {
         return data.commission?data.commission+'%':''
      }},

      {title:'', data:function(data) {
        let active=data.activeId?'<span class="text-success"><i class="icon-ok-squared"></i></span>':
          '<span class="text-danger"><i class="check-empty"></i></span>';
        let database=data.commissionId>0?'<span class="text-info"><i class="icon-database"></i></span>':'';
        return active+database;
      }, className:''}
    ];
    return columns;
  }

}

/*
generateConfigs=()=> {

  this.selectedEmployeeJobs=this.employeeJobCatalog.map(it=>it.id);
  this.selectedSchemas=this.schemaCatalog.map(it=>it.id);
  if(this.selectedSchemas.filter(it=> this.selectedSchemas.includes(3))){
    //select todas
    this.selectedCategories=this.categoryCatalog.map(it=>it.id);
  }else{
    //select 5 N/A CATEGORIA
    //this.selectedCategories=[5];
  }




  // crear configuraciones para consulta
  let configs:VwCommissionPanelModel[]=[];
  this.selectedAfiliates.forEach(afiId=> {
    let afiliate=this.afiliateCatalog.find(afi=> afi.id===afiId);
    this.selectedBusinessProducts.forEach(bpId=> {
      let businessProduct=this.businessProductCatalog.find(bp=> bp.idCatalogType===bpId);
      this.selectedEmployeeJobs.forEach(jobId=> {
        let employeeJob=this.employeeJobCatalog.find(j=> j.id===jobId);
        this.selectedProducts.forEach(prodId=> {
          let product=this.productCatalog.find(p=> p.idCatalogType===prodId);
          this.selectedAnchorTypes.forEach(atId=> {
            let anchorType=this.anchorTypeCatalog.find(a=> a.idCatalogType===atId);
            this.selectedPaymentTerms.forEach(ptId=> {
              let paymentTerm=this.paymentTermCatalog.find(ter=> ter.id===ptId);
              this.selectedSchemas.forEach(schId=> {
                let schema=this.schemaCatalog.find(s=> s.id===schId);
                this.selectedPromos.forEach(promoId=> {
                  let promo=this.promoCatalog.find(p=> p.id===promoId);
                  console.log("promoId "+promoId+"  promo="+JSON.stringify(promo));

                  let categoriesIds=schema.id===3?this.selectedCategories:[5];
                  categoriesIds.forEach(catId=> {
                    let category=this.categoryCatalog.find(cat=> cat.id===catId);
                    // crear configuracion
                    let config=this.creator.newVwCommissionPanelModel();
                    config.commissionId=0;
                    config.commission=schema.id===5?this.commission:null;
                    config.afiliateId=afiliate.id;
                    config.afiliateDesc=afiliate.description;
                    config.businessProductId=businessProduct.idCatalogType;
                    config.businessProductDesc=businessProduct.description;
                    config.employeeJobId=employeeJob.id;
                    config.employeeJobDesc=employeeJob.description;
                    config.financingTypeId=product.idCatalogType;
                    config.financingTypeDesc=product.description;
                    config.ownerTypeId=anchorType.idCatalogType;
                    config.ownerTypeDesc=anchorType.description;
                    config.paymentId=paymentTerm.id;
                    config.paymentDesc=paymentTerm.description;
                    config.productCategoryId=schema.id===3?category.id:5;
                    config.productCategoryDesc=schema.id===3?category.description:'N/A CATEGORIA';
                    config.promotionId=promo.description;
                    config.schemaId=schema.id;
                    config.schemaDesc=schema.description;
                    configs.push(config);
                  })
                })
              })
            })
          })
        })
      })
    })
  });
  console.log(configs)

  // enviar configuraciones a consulta
  this.vwComissionPanelService.validate(configs)
  .subscribe((resp:any)=> {
    if(resp && resp.codeHttpStatus===200) {
      this.datatableElement.dtInstance.then((dtInstance)=> {
        this.tableItemsFiltered=resp.data;
        this.tableItemsFiltered.forEach((it, ind)=> {
          if(it.commissionId<=0) it.commissionId=-(ind+1);
        });
        dtInstance.clear();
        dtInstance.rows.add(this.tableItemsFiltered).draw(false);
      });
    }
  })
}*/
